export default __webpack_public_path__ + "static/media/DJI_0989.MP4.00_01_52_04.Still008.ac892128.jpg";